import { combineReducers } from '@reduxjs/toolkit';
import { reducer as actionPlanReducer } from '../slices/actionPlan';

const rootReducer = combineReducers({
  actionPlan: actionPlanReducer
});

export default rootReducer;
